/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./App.css";
import { Image, Responsive, Grid } from "semantic-ui-react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import leftRoutes from "./components/routes/left-routes";
import rightRoutes from "./components/routes/right-routes";
import Footer from "./components/footer";
import Signup from "../src/components/signup";
import SignupType from "../src/components/signup-type";
import TermsOfService from "../src/components/terms-of-service";
import Logo from "./media/kx-logo.png";
import SignupImg from "./media/rs-backgrounds/signup-login-bg.jpg";
import Favicon from 'react-favicon'
// import iconJd from './jd-image.ico'
import iconTI from './ti.ico'
import iconJB from './JB_icon.ico'
import iconCGTS from './cgts_icon.ico'
import iconSAT from "./SAT2.ico"
import iconMOTO from "./MOTO.ico"
import iconAL from './AL_icon.ico'
// import iconTCL from "./TCL.ico"
import {getWhiteLabelCustomerName,getWlTitleName,getWlFlexContaier,getWlMainContaier} from "./util.js"


// if (document.location.hostname !== 'localhost') console.log = () => {};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionData: {
        companyName: "",
        email: "",
        contactName: "",
        tempToken: "",
      },
      wlCustomerName: getWhiteLabelCustomerName(),    
      progressData: {
        basicInfo: "piece progress-gray",
        basicInfoCompany: "piece progress-gray",
        ai1: "piece progress-gray",
        ai2: "piece progress-gray",
        ai3: "piece progress-gray",
        ai4: "piece progress-gray",
        poa: "piece progress-gray",
        payment: "piece progress-gray",
        addTeam: "piece progress-gray"
      }, 
      
      background:getWhiteLabelCustomerName().length === 0 ? "mainContainer" : getWlMainContaier(getWhiteLabelCustomerName())

      
    };
    this.storeSessionData = this.storeSessionData.bind(this);
    this.storeProgressData = this.storeProgressData.bind(this);
    this.setBackground = this.setBackground.bind(this);
  }

  setBackground = (background) => {

    if(this.state.wlCustomerName.length>0){
      this.setState({ background: getWlMainContaier(this.state.wlCustomerName)});
    }
    this.setState({ background: background});
  }
  storeSessionData = (companyName, email, contactName, tempToken) => {
    console.log("Previous Parent State: " + JSON.stringify(this.state), "color: orange");
    this.setState(
      {
        sessionData: {
          companyName: companyName,
          email: email,
          contactName: contactName,
          tempToken: tempToken
        }
      },
      () => console.log("Updated Parent State: ", this.state)
    );
  };

  storeProgressData = (name, status) => {
    console.log("Previous Parent State: " + JSON.stringify(this.state), "color: blue");
    this.setState(
      {
        progressData: { ...this.state.progressData, [name]: status }
      },
      () => console.log("Updated Parent State: ", this.state)
    );
  };

  
  render() {
    const { background } = this.state;
    const leftRouteComponents = leftRoutes.map(({ path, component: C }, key) => <Route exact path={path} render={(props) => <C {...props} sessionData={this.state.sessionData} storeProgressData={this.storeProgressData} progressData={this.state.progressData} />} />);
    const rightRouteComponents = rightRoutes.map(({ path, component }, key) => <Route exact path={path} component={component} key={key} />);
    
    console.log("IS WHITELABEL ", window._env_.WL,this.state.background, window.location.hostname)
    let wlCustomerName = getWhiteLabelCustomerName()

    if (wlCustomerName.length  != 0) {
      document.title = getWlTitleName(wlCustomerName)
    }
    let icon = iconTI
    if (wlCustomerName === "TI") {
      icon = iconTI
    } else if (wlCustomerName === "JBH") {
      icon = iconJB
    } else if (wlCustomerName === "CGTS") {
      icon = iconCGTS
    } else if (wlCustomerName === "SAT") {
      icon = iconSAT
    } else if (wlCustomerName === "MOTO"){
      icon = iconMOTO
    } else if (wlCustomerName === "TCL"){
      icon = "favicon.svg"
    } else if (wlCustomerName === "AL"){
      icon = iconAL;
    }

    return (
      <Router>
        <div className={this.state.background}>
          <div className={wlCustomerName.length  != 0 ? getWlFlexContaier(wlCustomerName) : "flex-container"}>
            <div className={"top-content"}>
              {wlCustomerName.length  != 0  && <Favicon url={icon} />}

              {leftRouteComponents}

              <Route exact path="/signup" render={(props) => <SignupType storeUserType={this.storeUserType} storeSessionData={this.storeSessionData} storeProgressData={this.storeProgressData} progressData={this.state.progressData} />} />

              <Route exact path="/signup/:type" render={(props) => <Signup setBackground={this.setBackground} storeSessionData={this.storeSessionData} storeProgressData={this.storeProgressData} progressData={this.state.progressData} />} />

              <Route exact path="/email-confirmation/user/email/:tmp/confirm" render={(props) => <TermsOfService storeSessionData={this.storeSessionData} storeProgressData={this.storeProgressData} progressData={this.state.progressData} />} />

              {rightRouteComponents}
            </div>
            {wlCustomerName.length  == 0 &&  <Footer background={background} />}
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
